module.exports = __webpack_public_path__ + "static/img-diamond-blue-c7d192cd46f6d6fac36f31e27dae7fc3.jpg";